import { render, staticRenderFns } from "./sponsorInfo.vue?vue&type=template&id=233490d5&scoped=true&"
import script from "./sponsorInfo.vue?vue&type=script&lang=js&"
export * from "./sponsorInfo.vue?vue&type=script&lang=js&"
import style0 from "./sponsorInfo.vue?vue&type=style&index=0&id=233490d5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233490d5",
  null
  
)

export default component.exports